/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckAccessRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1
                      }
                    },
                    "nested": {
                      "identifier": {
                        "oneof": ["unitToken"]
                      }
                    }
                  },
                  "BootstrapCreatePrintableCheckRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1
                      }
                    },
                    "nested": {
                      "identifier": {
                        "oneof": ["unitToken"]
                      }
                    }
                  },
                  "CreatePrintableCheckRequest": {
                    "fields": {
                      "idempotenceKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "balanceId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "amount": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "payeeName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "memo": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "DownloadPrintableCheckRequest": {
                    "fields": {
                      "printableCheckId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CancelPrintableCheckRequest": {
                    "fields": {
                      "printableCheckId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transferToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BootstrapPrintableCheckManagementRequest": {
                    "fields": {
                      "printableCheckId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transferToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckAccessRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapCreatePrintableCheckRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CreatePrintableCheckRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.DownloadPrintableCheckRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.CancelPrintableCheckRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.BootstrapPrintableCheckManagementRequest) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckAccessRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 13:1
 */
export const PrintableCheckAccessRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckAccessRequest');
fixType(PrintableCheckAccessRequest);
Builder.createAndAttachToType(PrintableCheckAccessRequest);
/**
 * SOURCE BootstrapCreatePrintableCheckRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 19:1
 */
export const BootstrapCreatePrintableCheckRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapCreatePrintableCheckRequest');
fixType(BootstrapCreatePrintableCheckRequest);
Builder.createAndAttachToType(BootstrapCreatePrintableCheckRequest);
/**
 * SOURCE CreatePrintableCheckRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 25:1
 */
export const CreatePrintableCheckRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.CreatePrintableCheckRequest');
fixType(CreatePrintableCheckRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  balanceId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePrintableCheckRequest);
/**
 * SOURCE DownloadPrintableCheckRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 33:1
 */
export const DownloadPrintableCheckRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.DownloadPrintableCheckRequest');
fixType(DownloadPrintableCheckRequest, {
  printableCheckId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DownloadPrintableCheckRequest);
/**
 * SOURCE CancelPrintableCheckRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 37:1
 */
export const CancelPrintableCheckRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.CancelPrintableCheckRequest');
fixType(CancelPrintableCheckRequest, {
  printableCheckId: {
    notEmpty: true
  },
  transferToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CancelPrintableCheckRequest);
/**
 * SOURCE BootstrapPrintableCheckManagementRequest @ squareup/bbfrontend/common/printable_check/printable_check_requests.proto at 42:1
 */
export const BootstrapPrintableCheckManagementRequest = $root.lookupType('squareup.bbfrontend.common.printable_check.BootstrapPrintableCheckManagementRequest');
fixType(BootstrapPrintableCheckManagementRequest, {
  printableCheckId: {
    notEmpty: true
  },
  transferToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BootstrapPrintableCheckManagementRequest);